export const ZERO = 0;
